module.exports = __webpack_public_path__ + "static/media/marketing-icon-selected.b799b3bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marketing-icon-selected.svg
// module id = 1923
// module chunks = 0